(() => {
  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-nav');
  if (menuButton && menu) {
    const close = () => { menu.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); menuButton.setAttribute('aria-label', 'Open menu'); document.body.classList.remove('menu-open'); };
    menuButton.addEventListener('click', () => { const open = menu.hidden; menu.hidden = !open; menuButton.setAttribute('aria-expanded', String(open)); menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); document.body.classList.toggle('menu-open', open); });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduced) {
    const observer = new IntersectionObserver((entries) => { entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }); }, { threshold: .08 });
    document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
  } else document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-visible'));
  const hero = document.querySelector('.hero');
  if (hero && !reduced && window.matchMedia('(hover: hover)').matches) {
    let raf = 0;
    hero.addEventListener('pointermove', e => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const x = (e.clientX / window.innerWidth - .5), y = (e.clientY / window.innerHeight - .5);
        const logo = hero.querySelector('.hero-logo-wrap');
        if (logo) logo.style.transform = `translate(${x * 15}px, ${y * 12}px)`;
        const halo = hero.querySelector('.hero-halo');
        if (halo) halo.style.transform = `translate(${x * 30}px, ${y * 25}px)`;
        raf = 0;
      });
    });
    hero.addEventListener('pointerleave', () => { const logo = hero.querySelector('.hero-logo-wrap'); if (logo) logo.style.transform = ''; });
  }
  document.querySelectorAll('[data-quantity-up], [data-quantity-down]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (button.hasAttribute('data-quantity-up') ? 1 : -1));
  }));
  const variant = document.querySelector('[data-variant-select]');
  if (variant) variant.addEventListener('change', () => {
    const chosen = variant.selectedOptions[0];
    const price = document.querySelector('[data-product-price]');
    const button = document.querySelector('.add-to-cart');
    if (price) price.textContent = chosen.dataset.price;
    if (button) { button.disabled = chosen.dataset.available !== 'true'; button.querySelector('[data-add-label]').textContent = button.disabled ? 'SOLD OUT' : 'ADD TO BAG'; }
    const url = new URL(location.href); url.searchParams.set('variant', chosen.value); history.replaceState({}, '', url);
  });
})();

// Re-initialize when Shopify replaces a section in the theme editor.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let chapters = [], frame = 0;
  const clamp = v => Math.min(1, Math.max(0, v));
  const paint = () => {
    frame = 0;
    const vh = innerHeight;
    chapters.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;
      const p = clamp(-rect.top / Math.max(1, rect.height - vh));
      const reveal = clamp(p / .25);
      const exit = 1 - clamp((p - .87) / .13) * .65;
      const caption = clamp((p - .18) / .22);
      el.style.setProperty('--p', p.toFixed(4));
      el.style.setProperty('--reveal', reveal.toFixed(4));
      el.style.setProperty('--exit', exit.toFixed(4));
      el.style.setProperty('--caption', caption.toFixed(4));
      el.style.setProperty('--lift', `${(1 - reveal) * 160 - clamp((p - .7) / .3) * 35}px`);
      el.style.setProperty('--scale', (.74 + reveal * .26 + p * .05).toFixed(4));
      el.style.setProperty('--rotation', `${-9 * (1 - reveal)}deg`);
      el.style.setProperty('--word-x', `${(p - .5) * -120}px`);
      // Hidden captions must not leave invisible links in keyboard navigation.
      el.querySelectorAll('.chapter-caption a').forEach(a => {
        a.style.visibility = caption < .05 ? 'hidden' : 'visible';
      });
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
  const init = () => {
    chapters = [...document.querySelectorAll('[data-chapter]')];
    document.documentElement.classList.toggle('cinema-enhanced', !reduced.matches);
    if (reduced.matches) {
      chapters.forEach(el => { el.querySelectorAll('a').forEach(a => a.style.visibility = 'visible'); });
    } else schedule();
  };
  addEventListener('scroll', () => { if (!reduced.matches) schedule(); }, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', init);
  document.addEventListener('shopify:section:load', () => {
    init();
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-visible'));
  });
  document.addEventListener('shopify:block:select', event => {
    const chapter = event.target.closest('[data-chapter]');
    if (chapter) window.scrollTo({ top: scrollY + chapter.getBoundingClientRect().top + (chapter.offsetHeight - innerHeight) * .55, behavior: 'instant' });
  });
  init();
})();

(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-halloween]').forEach(poster => {
      if (poster.dataset.ready) return;
      poster.dataset.ready = 'true';
      poster.querySelectorAll('[data-view-button]').forEach(button => button.addEventListener('click', () => {
        poster.querySelectorAll('[data-view-button]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        poster.querySelectorAll('[data-view]').forEach(view => view.classList.toggle('is-active', view.dataset.view === button.dataset.viewButton));
      }));
    });
    root.querySelectorAll('[data-volumes]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[role=tab]')];
      function activate(tab) {
        tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
        group.querySelectorAll('[role=tabpanel]').forEach(panel => panel.hidden = panel.id !== tab.getAttribute('aria-controls'));
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (e.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { e.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
    });
  }
  setup();
  document.addEventListener('shopify:section:load', () => setup());
  let ticking = false;
  addEventListener('scroll', () => {
    if (ticking || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    ticking = true;
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-halloween]').forEach(p => {
        const rect = p.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < innerHeight) p.style.setProperty('--poster-progress', Math.min(1,Math.max(0,-rect.top/rect.height)));
      });
      ticking = false;
    });
  }, {passive:true});
})();
